import { useDispatch, useSelector } from "react-redux";
import Button from "../components/Buttons/button";
import Input from "../components/Input";
import { openModals } from "../redux/modal.slice";
import ModalsEnum from "../enums/modal.enum";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { changeUsername_req, currentUser_req } from "../api/user.api";
import { setMeData } from "../redux/me.slice";
import { getAuthToken } from "../utils/authToken";

const Profile = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const user = useSelector((state) => state.me?.data);
  const [value, setValue] = useState("");

  useEffect(() => {
    if (!getAuthToken()) {
      navigation("/");
      dispatch(
        openModals({
          modalIds: [ModalsEnum.SIGN_IN_MODAL],
        })
      );
    }
  }, []);

  const handleChangePassword = () => {
    dispatch(
      openModals({
        modalIds: [ModalsEnum.CHANGE_PASSWORD_MODAL],
        modalData: [
          {
            className: "change-password-modal",
          },
        ],
      })
    );
  };
  useEffect(() => {
    setValue(user?.username);
  }, [user]);

  const handleDeleteAccount = () => {
    dispatch(
      openModals({
        modalIds: [ModalsEnum.DELETE_ACCOUNT_MODAL],
        modalData: [
          {
            className: "delete-account-modal",
          },
        ],
      })
    );
  };

  const handleChange = (e) => {
    setValue(e?.target?.value);
  };

  const cancelBtn = () => {
    navigation("/");
  };

  const getUser = async () => {
    const response = await currentUser_req();
    dispatch(setMeData(response?.user));
  };

  const saveChange = async () => {
    try {
      const response = await changeUsername_req(value);
      getUser();
    } catch (e) {
      console.log("e", e);
    }
  };

  return (
    <div className="profile-page">
      <div className="container">
        <div className="personal-info mb-24">
          <h4 className="mb-4">Personal info</h4>
          <p className="mb-24">Update your personal details here.</p>
          <div className="personal-info__box">
            <div className="personal-info__box__head">
              <form className="mb-24">
                <Input
                  id={"username"}
                  label={"User Name"}
                  placeholder={"Enter your username"}
                  name={"username"}
                  onChange={handleChange}
                  defaultValue={value}
                  className="mb-16"
                  error={value?.length > 0 ? false : true}
                  errorMessage={value?.length < 1 ? "Username is Required" : ""}
                />
                <Input
                  id={"email"}
                  label={"Email"}
                  placeholder={"Enter your email"}
                  defaultValue={user?.email}
                  name={"email"}
                  type={"email"}
                  disabled={true}
                />
              </form>
              <button
                className="change-password-button"
                onClick={handleChangePassword}
              >
                Change password
              </button>
            </div>
            <div className="personal-info__box__foo flex flex-align-center flex-justify-end">
              <Button
                text={"Cancel"}
                type={"outline"}
                className={"mr-12"}
                onClick={cancelBtn}
              />
              <Button
                text={"Save changes"}
                onClick={saveChange}
              />
            </div>
          </div>
        </div>
        <div className="account-control">
          <h4 className="mb-4">Account Control</h4>
          <p className="mb-24">Permanently delete your account and all data.</p>
          <div className="delete-account-box">
            <button onClick={handleDeleteAccount}>Delete Account</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
